import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=31d8889e&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec_plaisir/b2b/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d8889e')) {
      api.createRecord('31d8889e', component.options)
    } else {
      api.reload('31d8889e', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=31d8889e&", function () {
      api.rerender('31d8889e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Loading.vue"
export default component.exports